import { Navigate } from "react-router-dom";
import useUser from "../../hooks/useUser";

// Permission levels

export const DB_PERMISSION_LEVEL = Object.freeze({
	ACCESS: "access",
	ADMIN: "admin",
});

// Module keys — must match dbPermissions object keys from useUser()
export const DB_PERMISSION_MODULE = Object.freeze({
	SALES_NEWS_VGSAP: "salesNewsVgsap",
	// Future modules:
	// ANOTHER_MODULE: "anotherModule",
});

// Generic route guard for DB-driven permissions
// Checks dbPermissions object from useUser()
// module: key from DB_PERMISSION_MODULE
// level: ACCESS or ADMIN (default: ACCESS)
function DbPermissionGuard({ module, level = DB_PERMISSION_LEVEL.ACCESS, redirectTo = "/", children }) {
	const { dbPermissions } = useUser();
	const perm = dbPermissions?.[module];

	const hasAccess = level === DB_PERMISSION_LEVEL.ADMIN ? !!perm?.isAdmin : !!perm?.hasAccess;

	if (!hasAccess) {
		return <Navigate to={redirectTo} replace />;
	}

	return children;
}

export default DbPermissionGuard;
